import { computed, ref } from 'vue';

export function useSelection() {
  const selectedIds = ref([]);

  const isSelected = (id) => selectedIds.value.includes(id);

  const toggle = (id, checked) => {
    if (checked) {
      if (!isSelected(id)) selectedIds.value = [...selectedIds.value, id];
      return;
    }
    selectedIds.value = selectedIds.value.filter((candidate) => candidate !== id);
  };

  const clear = () => {
    selectedIds.value = [];
  };

  return {
    selectedIds,
    isSelected,
    toggle,
    clear,
    selectedCount: computed(() => selectedIds.value.length),
  };
}
